// import React, { useState, useEffect } from "react";
// import Container from "react-bootstrap/Container";
// import Col from "react-bootstrap/Col";
// import Row from "react-bootstrap/Row";
// import Form from "react-bootstrap/Form";

// import DeleteClassButton from "./DeleteClassButton";
// import EditClassDetailsSpecial from "./EditClassDetailsSpecial";
// import EditClassTeacherSpecialDetails from "./EditClassTeacherSpecialDetails";
// import SaveClassDetailsSpecial from "./SaveClassDetailsSpecial";
// import BackButton from "./BackButton";

// import { getClassOwnerChangeReasons, whoami } from "../services/APIClient";

// import "./ClassOverview.css";

// function ClassSettingsSpecialOverview(props) {
//   let classDetails = props.classDetails.classDetails;
//   let gradeLevel = props.gradeLevel;
//   let name = props.name;
//   let teachers = props.teachers.teachers;
//   let teacherid = props.teacherid; // Assuming teacherid is passed as a prop
//   let sharedWith = props.sharedWith;
//   let qrCodeDetails = props.qrCodeDetails;
//   let classid = props.classid;
//   let schoolid = props.schoolid.schoolid;

//   console.log(classDetails, "DEETS");

//   // State for new class name and grade
//   let [newClassName, setNewClassName] = useState(`${name}`);
//   let [newGrade, setNewGrade] = useState("");
//   let [classTeacherName, setClassTeacherName] = useState("");
//   const [newClassTeacherId, setNewClassTeacherId] = useState(""); // New state for selected teacher ID
//   const [isNameUpdated, setIsNameUpdated] = useState(false);
//   const [classOwnerName, setClassOwnerName] = useState("");
//   const [classOwnerChangeReason, setClassOwnerChangeReason] = useState(""); // State for selected reason
//   const [classOwnerChangeReasons, setClassOwnerChangeReasons] = useState([]); // State for reasons array
//   const [showChangeReasonDropdown, setShowChangeReasonDropdown] =
//     useState(false); // To toggle dropdown
//   const [changeReasons, setChangeReasons] = useState([]); // To store fetched reasons
//   const [selectedReason, setSelectedReason] = useState({ id: "", reason: "" });

//   // Fetch class owner change reasons
//   useEffect(() => {
//     const fetchClassOwnerChangeReasons = async () => {
//       try {
//         const reasons = await getClassOwnerChangeReasons();
//         console.log(reasons);
//         setClassOwnerChangeReasons(reasons); // Store the reasons array
//       } catch (error) {
//         console.error("Error fetching class owner change reasons:", error);
//       }
//     };

//     fetchClassOwnerChangeReasons();
//   }, []);

//   useEffect(() => {
//     // Find the teacher's name based on teacherid
//     const teacher = teachers.find((teacher) => teacher.id === teacherid);
//     if (teacher) {
//       setClassTeacherName(teacher.name);
//       console.log("Class Teacher Name:", teacher.name);
//     } else {
//       console.log("Teacher not found");
//     }
//   }, [teacherid, teachers]);

//   // Function to update class name state
//   const updateClassName = (name) => {
//     setNewClassName(name);
//   };

//   // Function to update grade state
//   const updateGrade = (grade) => {
//     setNewGrade(grade);
//   };

//   // Inline styles for the text box
//   const textBoxStyle = {
//     border: "1px solid #ddd", // Light gray border
//     borderRadius: "0.25rem", // Rounded corners
//     padding: "1rem", // Padding
//     marginBottom: "1rem", // Margin below
//     fontSize: "18px", // Font size
//     fontWeight: "bold", // Font weight
//     textAlign: "center", // Center align text
//     // color: "#333", // Dark text color
//   };

//   return (
//     <div className="class-overview-container">
//       <Container className="container-shape">
//         <Row className="page-description-bar">
//           <Col>
//             <h2 className="page-description-header">{name}</h2>
//             <p>Edit the details of your class.</p>
//           </Col>
//           <Col>
//             <Row>
//               {/* <Col>
//                 <DeleteClassButton classDetails={classDetails} />
//               </Col> */}
//             </Row>
//           </Col>
//         </Row>
//         <hr />
//         <Row className="button-container">
//           <Col className="col-7 vertical-border">
//             <br />
//             <Form className="form">
//               <div style={textBoxStyle}>
//                 <p>
//                   Please name classroom as it appears in your school MIS system
//                   e.g Aladdin / Arbor / i-SAMS - this will assist with reporting
//                   later.
//                 </p>
//               </div>
//               {/* Old Class Name Field */}
//               <Form.Group as={Row} className="mb-3" controlId="old-class-name">
//                 <Form.Label className="label" column sm="4">
//                   <p>Old Class Name</p>
//                 </Form.Label>
//                 <Col sm="8">
//                   <Form.Control
//                     placeholder={name}
//                     size="md"
//                     type="text"
//                     disabled
//                   />
//                 </Col>
//               </Form.Group>

//               {/* New Class Name Field */}
//             </Form>

//             {/* Flex container to hold the components side by side */}
//             <div className="edit-details-container">
//               <EditClassDetailsSpecial
//                 classDetails={classDetails}
//                 teachers={teachers}
//                 sharedWith={sharedWith}
//                 name={name}
//                 gradeLevel={gradeLevel}
//                 sendUpdateClassName={updateClassName}
//                 sendUpdateGrade={updateGrade}
//                 setIsNameUpdated={setIsNameUpdated}
//                 isNameUpdated={isNameUpdated}
//               />
//               <EditClassTeacherSpecialDetails
//                 currentTeacherName={classTeacherName}
//                 teachers={teachers}
//                 setNewClassTeacherId={setNewClassTeacherId}
//                 classOwnerName={classOwnerName}
//                 setClassOwnerChangeReason={setClassOwnerChangeReason} // Pass the setter for reason
//                 classOwnerChangeReasons={classOwnerChangeReasons} // Pass the reasons array
//                 setShowChangeReasonDropdown={setShowChangeReasonDropdown}
//                 setChangeReasons={setChangeReasons}
//                 setSelectedReason={setSelectedReason}
//                 showChangeReasonDropdown={showChangeReasonDropdown}
//                 changeReasons={changeReasons}
//               />
//             </div>

//             <Row className="button-placer">
//               <Col className="col-6">
//                 <BackButton />
//               </Col>
//               <Col className="col-6">
//                 <SaveClassDetailsSpecial
//                   newClassName={newClassName}
//                   newGrade={newGrade}
//                   classDetails={classDetails}
//                   teachers={teachers}
//                   newClassTeacherId={newClassTeacherId} // Pass the selected teacher ID
//                   schoolid={schoolid}
//                   isNameUpdated={isNameUpdated}
//                   sDetails={classDetails}
//                   gradeLevel={gradeLevel}
//                   classOwnerChangeReason={classOwnerChangeReason} // Pass the selected reason to save
//                   teacherid={teacherid}
//                   selectedReason={selectedReason}
//                   changeReasons={changeReasons}
//                   classOwnerId={classDetails.classOwnerId}
//                 />
//               </Col>
//             </Row>
//           </Col>
//           <Col className="col-5 right-side-container" style={{ display: 'flex', flexDirection: 'column', minHeight: '500px' }}>
//             {/* Optional: Uncomment if needed
//             <h3>Students Login</h3>
//             <Row>
//               <Col className="col-6">
//                 <ViewLogins
//                   name={name}
//                   label="View/Print QR Codes"
//                   gradeLevel={gradeLevel}
//                   qrCodeDetails={qrCodeDetails}
//                 />
//               </Col>
//               <Col className="col-6">
//                 <PrintAllLoginsButton
//                   name={name}
//                   label="Print Class QR Codes"
//                   qrCodeDetails={qrCodeDetails}
//                 />
//               </Col>
//             </Row> */}
            
//             {/* Push message to bottom */}
//             <div style={{ flexGrow: 1 }}></div>
            
//             {/* Two-part help section at the bottom of the right column */}
//             <div style={{ padding: '1rem' }}>
//               {/* Main instruction box */}
//               <div 
//                 style={{
//                   backgroundColor: '#e3f2fd',
//                   border: '2px solid #2196f3',
//                   borderRadius: '0.5rem',
//                   padding: '1.25rem',
//                   textAlign: 'center',
//                   boxShadow: '0 2px 8px rgba(33, 150, 243, 0.2)',
//                   marginBottom: '1rem'
//                 }}
//               >
//                 <p className="mb-0" style={{ 
//                   fontSize: '1rem', 
//                   fontWeight: '600',
//                   color: '#1976d2'
//                 }}>
//                   ℹ️ <strong>Important:</strong> Select from teachers who have created their account
//                 </p>
//               </div>

//               {/* Secondary instruction box for missing teachers */}
//               <div 
//                 style={{
//                   backgroundColor: '#fff3e0',
//                   border: '2px solid #ff9800',
//                   borderRadius: '0.5rem',
//                   padding: '1rem',
//                   textAlign: 'left',
//                   boxShadow: '0 2px 6px rgba(255, 152, 0, 0.15)'
//                 }}
//               >
//                 <p className="mb-2" style={{ 
//                   fontSize: '0.95rem', 
//                   fontWeight: '600',
//                   color: '#e65100',
//                   marginBottom: '0.5rem'
//                 }}>
//                   🔍 <strong>Teacher not in the list?</strong>
//                 </p>
//                 <ol className="mb-0" style={{ 
//                   fontSize: '0.875rem',
//                   color: '#bf360c',
//                   paddingLeft: '1.2rem',
//                   margin: 0
//                 }}>
//                   <li>Go to <strong>"Add Team Members"</strong> on the <strong>"Home"</strong> page</li>
//                   <li>Send invitation to the teacher</li>
//                   <li>Wait for them to create their account</li>
//                   <li>Return here to select them</li>
//                 </ol>
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// }

// export default ClassSettingsSpecialOverview;

import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";

import DeleteClassButton from "./DeleteClassButton";
import EditClassDetailsSpecial from "./EditClassDetailsSpecial";
import EditClassTeacherSpecialDetails from "./EditClassTeacherSpecialDetails";
import SaveClassDetailsSpecial from "./SaveClassDetailsSpecial";
import BackButton from "./BackButton";

import { getClassOwnerChangeReasons, whoami } from "../services/APIClient";

import "./ClassOverview.css";

function ClassSettingsSpecialOverview(props) {
  let classDetails = props.classDetails.classDetails;
  let gradeLevel = props.gradeLevel;
  let name = props.name;
  let teachers = props.teachers.teachers;
  let teacherid = props.teacherid; // Assuming teacherid is passed as a prop
  let sharedWith = props.sharedWith;
  let qrCodeDetails = props.qrCodeDetails;
  let classid = props.classid;
  let schoolid = props.schoolid.schoolid;

  console.log(classDetails, "DEETS");

  // State for new class name and grade
  let [newClassName, setNewClassName] = useState(`${name}`);
  let [newGrade, setNewGrade] = useState("");
  let [classTeacherName, setClassTeacherName] = useState("");
  const [newClassTeacherId, setNewClassTeacherId] = useState(""); // New state for selected teacher ID
  const [isNameUpdated, setIsNameUpdated] = useState(false);
  const [classOwnerName, setClassOwnerName] = useState("");
  const [classOwnerChangeReason, setClassOwnerChangeReason] = useState(""); // State for selected reason
  const [classOwnerChangeReasons, setClassOwnerChangeReasons] = useState([]); // State for reasons array
  const [showChangeReasonDropdown, setShowChangeReasonDropdown] = useState(false); // To toggle dropdown
  const [changeReasons, setChangeReasons] = useState([]); // To store fetched reasons
  const [selectedReason, setSelectedReason] = useState({ id: "", reason: "" });
  const [currentUserInfo, setCurrentUserInfo] = useState({});

  // Fetch current user info to get the inviting teacher's name
  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const whoamiResponse = await whoami();
        const { schoolid: userSchoolId, rollnumber, id, name, additionalRoles, countryid } = whoamiResponse.data.stakeholder;

        setCurrentUserInfo({
          schoolid: userSchoolId,
          id,
          name,
          additionalRoles,
          countryid,
          rollnumber
        });

        console.log("Current user info:", whoamiResponse.data.stakeholder);
      } catch (error) {
        console.error("Error fetching current user:", error);
      }
    };

    fetchCurrentUser();
  }, []);

  // Fetch class owner change reasons
  useEffect(() => {
    const fetchClassOwnerChangeReasons = async () => {
      try {
        const reasons = await getClassOwnerChangeReasons();
        console.log(reasons);
        setClassOwnerChangeReasons(reasons); // Store the reasons array
      } catch (error) {
        console.error("Error fetching class owner change reasons:", error);
      }
    };

    fetchClassOwnerChangeReasons();
  }, []);

  useEffect(() => {
    // Find the teacher's name based on teacherid
    const teacher = teachers.find((teacher) => teacher.id === teacherid);
    if (teacher) {
      setClassTeacherName(teacher.name);
      console.log("Class Teacher Name:", teacher.name);
    } else {
      console.log("Teacher not found");
    }
  }, [teacherid, teachers]);

  // Function to update class name state
  const updateClassName = (name) => {
    setNewClassName(name);
  };

  // Function to update grade state
  const updateGrade = (grade) => {
    setNewGrade(grade);
  };

  // Inline styles for the text box
  const textBoxStyle = {
    border: "1px solid #ddd", // Light gray border
    borderRadius: "0.25rem", // Rounded corners
    padding: "1rem", // Padding
    marginBottom: "1rem", // Margin below
    fontSize: "18px", // Font size
    fontWeight: "bold", // Font weight
    textAlign: "center", // Center align text
    // color: "#333", // Dark text color
  };

  return (
    <div className="class-overview-container">
      <Container className="container-shape">
        <Row className="page-description-bar">
          <Col>
            <h2 className="page-description-header">{name}</h2>
            <p>Edit the details of your class.</p>
          </Col>
          <Col>
            <Row>
              {/* <Col>
                <DeleteClassButton classDetails={classDetails} />
              </Col> */}
            </Row>
          </Col>
        </Row>
        <hr />
        <Row className="button-container">
          <Col className="col-7 vertical-border">
            <br />
            <Form className="form">
              <div style={textBoxStyle}>
                <p>
                  Please name classroom as it appears in your school MIS system
                  e.g Aladdin / Arbor / i-SAMS - this will assist with reporting
                  later.
                </p>
              </div>
              {/* Old Class Name Field */}
              <Form.Group as={Row} className="mb-3" controlId="old-class-name">
                <Form.Label className="label" column sm="4">
                  <p>Old Class Name</p>
                </Form.Label>
                <Col sm="8">
                  <Form.Control
                    placeholder={name}
                    size="md"
                    type="text"
                    disabled
                  />
                </Col>
              </Form.Group>

              {/* New Class Name Field */}
            </Form>

            {/* Flex container to hold the components side by side */}
            <div className="edit-details-container">
              <EditClassDetailsSpecial
                classDetails={classDetails}
                teachers={teachers}
                sharedWith={sharedWith}
                name={name}
                gradeLevel={gradeLevel}
                sendUpdateClassName={updateClassName}
                sendUpdateGrade={updateGrade}
                setIsNameUpdated={setIsNameUpdated}
                isNameUpdated={isNameUpdated}
              />
              <EditClassTeacherSpecialDetails
                currentTeacherName={classTeacherName}
                teachers={teachers}
                setNewClassTeacherId={setNewClassTeacherId}
                classOwnerName={classOwnerName}
                setClassOwnerChangeReason={setClassOwnerChangeReason}
                // Fixed props for API integration:
                schoolId={schoolid}
                rollnumber={currentUserInfo.rollnumber || currentUserInfo.id || ""}
                invitingTeacherName={currentUserInfo.name || ""}
                countryId={currentUserInfo.countryid || ""}
                classId={classid}
              />
            </div>

            <Row className="button-placer">
              <Col className="col-6">
                <BackButton />
              </Col>
              <Col className="col-6">
                <SaveClassDetailsSpecial
                  newClassName={newClassName}
                  newGrade={newGrade}
                  classDetails={classDetails}
                  teachers={teachers}
                  newClassTeacherId={newClassTeacherId} // Pass the selected teacher ID
                  schoolid={schoolid}
                  isNameUpdated={isNameUpdated}
                  sDetails={classDetails}
                  gradeLevel={gradeLevel}
                  classOwnerChangeReason={classOwnerChangeReason} // Pass the selected reason to save
                  teacherid={teacherid}
                  selectedReason={selectedReason}
                  changeReasons={changeReasons}
                  classOwnerId={classDetails.classOwnerId}
                  currentUserInfo={currentUserInfo}
                />
              </Col>
            </Row>
          </Col>
          <Col className="col-5 right-side-container" style={{ display: 'flex', flexDirection: 'column', minHeight: '500px' }}>
            <div style={{ flexGrow: 1 }}></div>

            {/* Updated help section reflecting new checkbox functionality */}
            <div style={{ padding: '1rem' }}>
              {/* Main instruction box - updated to reflect two options */}
              <div
                style={{
                  backgroundColor: '#e8f5e8',
                  border: '2px solid #28a745',
                  borderRadius: '0.5rem',
                  padding: '1.25rem',
                  textAlign: 'center',
                  boxShadow: '0 2px 8px rgba(40, 167, 69, 0.2)',
                  marginBottom: '1rem'
                }}
              >
                <p className="mb-0" style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#155724'
                }}>
                  ✅ <strong>Two Options Available:</strong><br />
                  Select existing teachers OR add new teachers directly
                </p>
              </div>

              {/* Option 1: Existing teachers */}
              <div
                style={{
                  backgroundColor: '#e3f2fd',
                  border: '1px solid #2196f3',
                  borderRadius: '0.5rem',
                  padding: '1rem',
                  textAlign: 'left',
                  marginBottom: '1rem'
                }}
              >
                <p className="mb-2" style={{
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  color: '#1976d2',
                  marginBottom: '0.5rem'
                }}>
                  📋 <strong>Option 1: Select Existing Teacher</strong>
                </p>
                <p className="mb-0" style={{
                  fontSize: '0.875rem',
                  color: '#1565c0',
                  margin: 0
                }}>
                  Choose from teachers who already have accounts in your school
                </p>
              </div>

              {/* Option 2: Add new teacher */}
              <div
                style={{
                  backgroundColor: '#fff3e0',
                  border: '1px solid #ff9800',
                  borderRadius: '0.5rem',
                  padding: '1rem',
                  textAlign: 'left'
                }}
              >
                <p className="mb-2" style={{
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  color: '#e65100',
                  marginBottom: '0.5rem'
                }}>
                  ➕ <strong>Option 2: Add New Teacher</strong>
                </p>
                <p className="mb-2" style={{
                  fontSize: '0.875rem',
                  color: '#bf360c',
                  marginBottom: '0.5rem'
                }}>
                  Check the box "Assign to teacher not yet in school" to add a teacher who doesn't have an account yet.
                </p>
                <p className="mb-0" style={{
                  fontSize: '0.8rem',
                  color: '#bf360c',
                  fontStyle: 'italic',
                  margin: 0
                }}>
                  💡 They'll receive an invitation to create their account and access the class.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ClassSettingsSpecialOverview;